import { createSlice } from "@reduxjs/toolkit";
import { FinancialReportAPI } from "../../services/financial-report";

const FinancialReport = createSlice({
  name: "Financial report",
  initialState: {
    financialReports: [],
    oneFinancialReport: null,
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FinancialReportAPI.getAll.fulfilled, (state, action) => {
        const { total, financial_reports } = action.payload;
        state.financialReports = financial_reports;
        state.total = total;
      })

      .addCase(FinancialReportAPI.getOne.fulfilled, (state, action) => {
        state.oneFinancialReport = action.payload;
      });
  },
});

export default FinancialReport;
